import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { isRedirectToType } from "@circle-react/helpers/paywallCustomizationHelpers";

export const useIsCountdownRedirectEnabled = () => {
  const { paywallCustomization } = usePaywallCheckoutContext();
  const { enabled: isCountdownEnabled } =
    paywallCustomization?.countdown_properties || {
      enabled: false,
    };

  const countdownProperties = paywallCustomization?.countdown_properties;

  return (
    isCountdownEnabled &&
    isRedirectToType(countdownProperties?.action?.action_type)
  );
};
